
export class Contact {
	public id: number;
	public name: string;
	public street: string;
	public zip_code: string;
	public locality: string;

  	constructor(
  	) {}
}
